// extracted by mini-css-extract-plugin
export default {"container":"BadgeUi_container__iMH1t","blue":"BadgeUi_blue__Nd4YU","green":"BadgeUi_green__FDlKO","red":"BadgeUi_red__EHQmR"};